import React from 'react';
import TopBarUserProfilePanel from './TopBarUserProfilePanel';
import Footer from './Footer';
import NavigateSpan from '../Utils/NavigateSpan';
import PopupHandler from '../Utils/PopupHandler';
import { analytics } from './AnalyticsManager';
import BannerAd from "../Ads/BannerAd";

export default class PageContainerWithLogo extends React.Component
{
  onLogoClick = async () =>
  {
    // Call the refresh callback if provided
    if( this.props.onLogoClick )
    {
      await this.props.onLogoClick();
    }
  }

  render()
  {
    return (
      <>
        <PopupHandler />

        <div className="top-bar">
          <NavigateSpan href={ "/" } className="meeples-logo" onClick={ this.onLogoClick }>
            <img src={ process.env.PUBLIC_URL + '/meeples-logo-256.png' } alt="Meeples Logo" />
          </NavigateSpan>

          <div className="top-bar-menu colour-dark-shade">

            <span
              className="top-bar-menu-link"
              onClick={ () =>
              {
                analytics.track( 'learnToPlay' );
                window.open( 'https://youtu.be/R1qh-lhxy9s?si=NnHgSdxPUtguwDwd', '_blank' ).focus();
              } }>
              LEARN TO PLAY
            </span>

          </div>

          <TopBarUserProfilePanel />

          <div className="clear-both" />

        </div>

        { !process.env.REACT_APP_DISABLE_AD_BANNERS &&
          (
            <div className="lobby-vertical-ad lobby-vertical-ad-left">
              <BannerAd
                slot="9532778304"
                format="auto"
                refreshSec={ process.env.REACT_APP_LOBBY_VERTICAL_AD_REFRESH_FREQUENCY ?? 60 }
              />
            </div>
          )
        }

        <div className="main-container-block">
          { this.props.children }
        </div>

        { !process.env.REACT_APP_DISABLE_AD_BANNERS &&
          (
            <div className="lobby-vertical-ad lobby-vertical-ad-right">
              <BannerAd
                slot="1754360630"
                format="auto"
                refreshSec={ process.env.REACT_APP_LOBBY_VERTICAL_AD_REFRESH_FREQUENCY ?? 60 }
              />
            </div>
          )
        }

        <Footer />
      </>
    );
  }
}
